import React, {useState} from "react";
import {Collapse} from "react-bootstrap";
import {
    IhioPrescriptionAdmissionType,
    IhioWrittenPrescriptionInfoType
} from "../../../../../types/ihioPrescriptionFilling";
import Icon from "../../../general/icon";

type PrescriptionFillingInfoProps = {
    prescriptionAdmissionData: IhioPrescriptionAdmissionType;
    writtenPrescriptionData: IhioWrittenPrescriptionInfoType | null;
}

const PrescriptionFillingInfo = ({
    prescriptionAdmissionData,
    writtenPrescriptionData
}: PrescriptionFillingInfoProps) => {

    const [showCollapse, setShowCollapse] = useState<boolean>(false)

    return(
        <>
            <div
                className={'w-100 rounded rounded-4 border border-primary bg-white py-2 px-4'}>
                <div className={'w-100 d-flex justify-content-between align-items-center'}>
                    <div className={'d-flex align-items-center gap-3'}>
                        <Icon name='info'/>
                        بیمار {writtenPrescriptionData?.patient?.patient?.firstName} {writtenPrescriptionData?.patient?.patient?.lastName} با کد
                        ملی {prescriptionAdmissionData?.nationalCode} خدماتی جهت ارائه دارد. برای
                        مشاهده نسخه تجویز شده بر روی دکمه کلیک نمایید.
                    </div>
                    <div className="d-flex justify-content-center">
                        <div
                            className="btn btn-light-blue rounded d-flex align-items-center fw-bold px-2 p-2"
                            onClick={() => setShowCollapse(!showCollapse)}
                        >
                            {showCollapse ? 'کمتر' : 'بیشتر'}
                        </div>
                    </div>
                </div>
                <Collapse in={showCollapse}>
                    <div>
                        <div className="row row-cols-lg-5 row-cols-md-3 row-cols-2 mt-3">
                            <div className={'d-flex align-items-center mb-3'}>
                                <span className={'text-gray-600 me-3'}>
                                    نام شریک کاری:
                                </span>
                                <span className={'text-gray-900'}>
                                    {writtenPrescriptionData?.partnerName}
                                </span>
                            </div>
                            <div className={'d-flex align-items-center mb-3'}>
                                <span className={'text-gray-600 me-3'}>
                                    نام همکار:
                                </span>
                                <span className={'text-gray-900'}>
                                    {writtenPrescriptionData?.providerName}
                                </span>
                            </div>
                            <div className={'d-flex align-items-center mb-3'}>
                                <span className={'text-gray-600 me-3'}>
                                    تخصص:
                                </span>
                                <span className={'text-gray-900'}>
                                    {writtenPrescriptionData?.providerSpecialty}
                                </span>
                            </div>
                            <div className={'d-flex align-items-center mb-3'}>
                                <span className={'text-gray-600 me-3'}>
                                    تاریخ مراجعه:
                                </span>
                                <span className={'text-gray-900'}>
                                    {writtenPrescriptionData?.creationDate || ''}
                                </span>
                            </div>
                            <div className={'d-flex align-items-center mb-3'}>
                                <span className={'text-gray-600 me-3'}>
                                    کد رهگیری:
                                </span>
                                <span className={'text-gray-900'}>
                                    {prescriptionAdmissionData?.trackingCode}
                                </span>
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>
        </>
    )
}


export default PrescriptionFillingInfo;